import React, { useState, useEffect } from "react";
import {
  FaWhatsapp,
  FaShareAlt,
  FaCopy,
  FaQrcode,
  FaArrowLeft,
  FaQuestionCircle,
  FaDownload,
  FaCheckCircle,
} from "react-icons/fa";
import {
  useGetLoginUserQuery,
  useMyProfileQuery,
} from "../../services/userApi";
import axios from "axios";
import { env } from "../../env";
import { buildReferralImageUrl } from "../../utils/cloudinarylink_replace";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../components/Dashboard/Header";
import BottomMenu from "../../components/Dashboard/BottomMenu";
import Modal from "react-modal";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  TwitterShareButton,
  EmailShareButton,
  FacebookIcon,
  WhatsappIcon,
  TelegramIcon,
  TwitterIcon,
  EmailIcon,
} from "react-share";

Modal.setAppElement("#root");

const ReferralScreen = () => {
  const { data: loginUser } = useGetLoginUserQuery();
  const { data: profileData } = useMyProfileQuery();
  const [genLink, setGenLink] = useState("");
  const [showQRModal, setShowQRModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [referralMessage, setReferralMessage] = useState("");
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [copied, setCopied] = useState(false);

  // Update window height on resize
  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Build the referral link
  // const buildLink = async () => {
  //   try {
  //     const response = await axios({
  //       method: "POST",
  //       url: env.firebase_dynamic_link_api,
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       data: {
  //         dynamicLinkInfo: {
  //           domainUriPrefix: "https://jointaskplanet.page.link",
  //           link: `https://taskplanet.org/register?sponsorId=${loginUser?.data?.username}`,
  //           androidInfo: {
  //             androidPackageName: "com.taskplanet",
  //             androidFallbackLink: `https://play.google.com/store/apps/details?id=com.taskplanet&referrer=sponsorId%3D${loginUser?.data?.username}`,
  //           },
  //           navigationInfo: {
  //             enableForcedRedirect: true,
  //           },
  //           socialMetaTagInfo: {
  //             socialTitle: "TaskPlanet",
  //             socialDescription: "Join TaskPlanet using the referral link!",
  //             socialImageLink:
  //               "https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1715406169/TaskPlanet/banner_1_jja6q3.webp",
  //           },
  //         },
  //       },
  //     });
  //     return response.data.shortLink;
  //   } catch (error) {
  //     console.error("Error creating short link:", error);
  //     return `https://taskplanet.org/register?sponsorid=${loginUser?.data?.username}`;
  //   }
  // };

  const buildLink = async () => {
    const username = loginUser?.data?.username;
    const domain = 'go.taskplanet.org'; // your ChottuLink domain
    const selectedPath = `join/${username}`;
    const customLink = `https://${domain}/${selectedPath}`;
    const destinationUrl = `https://business.taskplanet.org/register?sponsorId=${username}`;
  
    try {
      const response = await axios.post(
        'https://api2.chottulink.com/chotuCore/pa/v1/create-link',
        {
          domain: domain,
          selected_path: selectedPath,
          destination_url: destinationUrl,
          link_name: `Referral-${username}`,
          android_behavior: 2,
          ios_behavior: 2,
          utm_source: 'referral',
          utm_medium: 'invite',
          utm_campaign: 'user-growth',
          social_title: 'TaskPlanet',
          social_description: 'Join TaskPlanet using the referral link!',
          social_image_url: buildReferralImageUrl(username),
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'API-KEY': 'c_api_19LZeRilmkFQj5vp6DxtKSH0kiXYXSR1',
          },
        }
      );
  
      console.log(response.data?.short_url)
  
      if (response.status === 201 && response.data?.short_url) {
        return response.data.short_url;
      } else {
        throw new Error('ChottuLink creation failed');
      }
    } catch (error) {
      console.error('ChottuLink error:', error.response?.data || error.message);
      return customLink;
    }
  };
  // Build the referral message
  const buildMessage = () => {
    return `Hey there! Ready to earn money effortlessly? 🚀\n\nCome join me on Task Planet – the ultimate money-earning app where you complete simple tasks and win rewards! Plus, get a fantastic 900 Points Welcome Bonus 🥳. Plus, you have a chance to earn 30,000+ points per referral 🎉\n\nHere's how to start:\n1️⃣ Download the Task Planet App: ${genLink}\n2️⃣ Use my Sponsor ID: ${
      profileData?.data?.[0]?.username?.toUpperCase() || ""
    }\n3️⃣ Complete tasks & start earning instantly! 💰\n\nSo what are you waiting for? Let's earn big together! 💸🔥`;
  };

  // Set the generated link and message
  const setUrl = async () => {
    const shortLink = await buildLink();
    setGenLink(shortLink);
    setQrCodeUrl(
      `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(
        shortLink
      )}`
    );
  };

  useEffect(() => {
    if (loginUser?.data?.username) {
      setUrl();
    }
  }, [loginUser?.data?.username]);

  useEffect(() => {
    if (genLink) {
      setReferralMessage(buildMessage());
    }
  }, [genLink, profileData]);

  // Share via WhatsApp
  const shareViaWhatsapp = () => {
    const message = encodeURIComponent(referralMessage);
    window.open(`https://wa.me/?text=${message}`, "_blank");
    setShowShareModal(false);
  };

  // Copy to clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralMessage);
    setCopied(true);
    toast.success("Referral message copied to clipboard");
    setTimeout(() => setCopied(false), 2000);
    setShowShareModal(false);
  };

  // Download QR code
  const downloadQRCode = async () => {
    try {
      const response = await fetch(qrCodeUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "taskplanet-referral-qr.png";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading QR code:", error);
      toast.error("Failed to download QR code");
    }
  };

  // Share QR Code
  const shareQRCode = async () => {
    try {
      const response = await fetch(qrCodeUrl);
      const blob = await response.blob();

      if (navigator.share) {
        await navigator.share({
          files: [new File([blob], "taskplanet-qr.png", { type: "image/png" })],
          title: "TaskPlanet Referral",
          text: "Scan this QR code to join Task Planet: " + genLink,
        });
      } else {
        toast.info("Share functionality not supported on this browser");
        copyToClipboard();
      }
    } catch (error) {
      console.warn("Error sharing QR code:", error);
      toast.error("Failed to share QR code");
    }
  };

  // Share via other social platforms
  const shareViaFacebook = () => {
    // Handled by the FacebookShareButton component
    setShowShareModal(false);
  };

  const shareViaTelegram = () => {
    window.open(
      `https://t.me/share/url?url=${encodeURIComponent(
        genLink
      )}&text=${encodeURIComponent(referralMessage)}`,
      "_blank"
    );
    setShowShareModal(false);
  };

  const shareViaTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        `${referralMessage.substring(0, 240)}...`
      )}`,
      "_blank"
    );
    setShowShareModal(false);
  };

  const shareViaEmail = () => {
    window.open(
      `mailto:?subject=${encodeURIComponent(
        "Join TaskPlanet with my referral"
      )}&body=${encodeURIComponent(referralMessage)}`,
      "_blank"
    );
    setShowShareModal(false);
  };

  // Calculate dynamic container height based on screen size
  const containerStyle = {
    backgroundColor: "#fff",
    height: "100%",
    maxWidth: "450px",
    width: "100%",
    margin: "0 auto",
    position: "relative",
    fontFamily: "Arial, sans-serif",
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  };

  const contentContainerStyle = {
    flex: 1,
    overflowY: "auto",
    paddingBottom: "70px", // Space for bottom menu
  };

  // Calculate bottom padding to avoid content being hidden behind menu
  const bottomMenuHeight = 60; // Approximate height of the bottom menu

  return (
    <div className="referral-screen" style={containerStyle}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#FBEC5D",
          padding: "12px 16px",
          position: "sticky",
          top: 0,
          zIndex: 100,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <button
          onClick={() => window.history.back()}
          style={{
            background: "none",
            border: "none",
            marginRight: "10px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FaArrowLeft size={22} color="black" />
        </button>
        <span
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#000",
            flex: 1,
          }}
        >
          Refer Task Planet to your friends today
        </span>
        <button
          onClick={() =>
            toast.info(
              "Referral Help\n\nShare Task Planet with your friends to earn rewards! Each successful referral earns you points.",
              { autoClose: 5000 }
            )
          }
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FaQuestionCircle size={22} color="black" />
        </button>
      </div>

      <div style={contentContainerStyle}>
        {/* Quick Share Options */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            padding: "16px",
            backgroundColor: "#fff",
            marginBottom: "16px",
            borderRadius: "10px",
            margin: "16px",
            border: "1px solid #eee",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <button
            onClick={shareViaWhatsapp}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              background: "none",
              border: "none",
              cursor: "pointer",
              width: "70px",
              transition: "transform 0.2s",
            }}
            className="hover-scale"
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "#25D366",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "8px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              <FaWhatsapp size={24} color="white" />
            </div>
            <span
              style={{ fontSize: "12px", color: "#000", fontWeight: "500" }}
            >
              WhatsApp
            </span>
          </button>

          <button
            onClick={() => setShowShareModal(true)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              background: "none",
              border: "none",
              cursor: "pointer",
              width: "70px",
              transition: "transform 0.2s",
            }}
            className="hover-scale"
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "#8a2be2",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "8px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              <FaShareAlt size={24} color="white" />
            </div>
            <span
              style={{ fontSize: "12px", color: "#000", fontWeight: "500" }}
            >
              Share
            </span>
          </button>

          <button
            onClick={copyToClipboard}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              background: "none",
              border: "none",
              cursor: "pointer",
              width: "70px",
              transition: "transform 0.2s",
              position: "relative",
            }}
            className="hover-scale"
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "#4fc3f7",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "8px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              {copied ? (
                <FaCheckCircle size={24} color="white" />
              ) : (
                <FaCopy size={24} color="white" />
              )}
            </div>
            <span
              style={{ fontSize: "12px", color: "#000", fontWeight: "500" }}
            >
              {copied ? "Copied!" : "Copy"}
            </span>
            {copied && (
              <div
                style={{
                  position: "absolute",
                  top: "-30px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "rgba(0,0,0,0.7)",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  zIndex: 10,
                }}
              >
                Copied to clipboard!
              </div>
            )}
          </button>

          <button
            onClick={() => setShowQRModal(true)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              background: "none",
              border: "none",
              cursor: "pointer",
              width: "70px",
              transition: "transform 0.2s",
            }}
            className="hover-scale"
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "#ff7043",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "8px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              <FaQrcode size={24} color="white" />
            </div>
            <span
              style={{ fontSize: "12px", color: "#000", fontWeight: "500" }}
            >
              QR Code
            </span>
          </button>
        </div>

        {/* Referral Rewards Section */}
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "16px",
            margin: "0 16px 16px 16px",
            border: "1px solid #eee",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            textAlign: "center",
          }}
        >
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "12px",
              color: "#000",
            }}
          >
            Referral Rewards
          </h3>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <div
              style={{
                flex: 1,
                padding: "12px",
                backgroundColor: "#f9f9f9",
                borderRadius: "10px",
                marginRight: "8px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                borderLeft: "4px solid #009688",
              }}
            >
              <span
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#009688",
                }}
              >
                30K+
              </span>
              <p style={{ fontSize: "12px", marginTop: "4px", color: "#666" }}>
                Points per referral
              </p>
            </div>
            <div
              style={{
                flex: 1,
                padding: "12px",
                backgroundColor: "#f9f9f9",
                borderRadius: "10px",
                marginLeft: "8px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                borderLeft: "4px solid #ff7043",
              }}
            >
              <span
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#ff7043",
                }}
              >
                900
              </span>
              <p style={{ fontSize: "12px", marginTop: "4px", color: "#666" }}>
                Welcome bonus
              </p>
            </div>
          </div>

          <p
            style={{
              fontSize: "14px",
              color: "#666",
              marginBottom: "12px",
            }}
          >
            Invite friends and start earning rewards today!
          </p>
        </div>

        {/* Mobile App Promotion */}
        <div style={{ padding: "0 16px 16px 16px", marginBottom: "20px" }}>
          <div
            style={{
              textAlign: "center",
              padding: "20px",
              border: "1px dashed #ddd",
              borderRadius: "10px",
              backgroundColor: "#f9f9f9",
              boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05)",
            }}
          >
            <p style={{ color: "#666", marginBottom: "16px" }}>
              Direct Refer to Contact is only available in the mobile app
            </p>
            <button
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.taskplanet",
                  "_blank"
                )
              }
              style={{
                backgroundColor: "#FBEC5D",
                color: "#000",
                border: "none",
                padding: "12px 24px",
                borderRadius: "10px",
                fontWeight: "bold",
                cursor: "pointer",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                transition: "all 0.2s ease",
                marginTop:"2rem"
              }}
              className="hover-grow"
            >
              Get Mobile App
            </button>
          </div>
        </div>
      </div>
      {/* QR Code Modal */}
      <Modal
        isOpen={showQRModal}
        onRequestClose={() => setShowQRModal(false)}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "320px",
            borderRadius: "12px",
            padding: "20px",
            backgroundColor: "white",
            border: "1px solid #eee",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
          overlay: {
            backgroundColor: "rgba(0,0,0,0.7)",
            zIndex: 1000,
          },
        }}
      >
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            marginBottom: "20px",
            color: "#000",
            textAlign: "center",
          }}
        >
          Your Referral QR Code
        </h3>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "10px 0",
          }}
        >
          {qrCodeUrl && (
            <img
              src={qrCodeUrl}
              alt="Referral QR Code"
              style={{
                width: "200px",
                height: "200px",
                borderRadius: "12px",
                border: "1px solid #eee",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            />
          )}
        </div>

        <div
          style={{
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            padding: "12px",
            margin: "15px 0",
            wordBreak: "break-all",
            fontSize: "14px",
            border: "1px solid #eee",
          }}
        >
          {genLink || "Generating link..."}
        </div>

        <div style={{ display: "flex", gap: "12px", marginTop: "15px" }}>
          <button
            onClick={downloadQRCode}
            style={{
              backgroundColor: "#009688",
              color: "white",
              border: "none",
              padding: "12px 0",
              borderRadius: "10px",
              fontWeight: "bold",
              width: "100%",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              transition: "all 0.2s ease",
            }}
            className="hover-button"
          >
            <FaDownload style={{ marginRight: "8px" }} /> Download
          </button>

          <button
            onClick={shareQRCode}
            style={{
              backgroundColor: "#FBEC5D",
              color: "#000",
              border: "none",
              padding: "12px 0",
              borderRadius: "10px",
              fontWeight: "bold",
              width: "100%",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              transition: "all 0.2s ease",
            }}
            className="hover-button"
          >
            <FaShareAlt style={{ marginRight: "8px" }} /> Share
          </button>
        </div>
      </Modal>

      {/* Share Modal */}
      <Modal
        isOpen={showShareModal}
        onRequestClose={() => setShowShareModal(false)}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "320px",
            borderRadius: "12px",
            padding: "20px",
            backgroundColor: "white",
            border: "1px solid #eee",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
          overlay: {
            backgroundColor: "rgba(0,0,0,0.7)",
            zIndex: 1000,
          },
        }}
      >
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            marginBottom: "24px",
            color: "#000",
            textAlign: "center",
          }}
        >
          Share Referral Link
        </h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "20px",
            justifyItems: "center",
          }}
        >
          <div
            onClick={shareViaWhatsapp}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <WhatsappShareButton
              url={genLink}
              title="Join TaskPlanet"
              separator=" - "
              onClick={shareViaWhatsapp}
            >
              <WhatsappIcon size={48} round />
            </WhatsappShareButton>
            <span style={{ fontSize: "12px", marginTop: "8px" }}>WhatsApp</span>
          </div>

          <div
            onClick={shareViaFacebook}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <FacebookShareButton
              url={genLink}
              quote={referralMessage}
              onClick={shareViaFacebook}
            >
              <FacebookIcon size={48} round />
            </FacebookShareButton>
            <span style={{ fontSize: "12px", marginTop: "8px" }}>Facebook</span>
          </div>

          <div
            onClick={shareViaTelegram}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <TelegramShareButton
              url={genLink}
              title="Join TaskPlanet"
              onClick={shareViaTelegram}
            >
              <TelegramIcon size={48} round />
            </TelegramShareButton>
            <span style={{ fontSize: "12px", marginTop: "8px" }}>Telegram</span>
          </div>

          <div
            onClick={shareViaTwitter}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <TwitterShareButton
              url={genLink}
              title="Join TaskPlanet"
              onClick={shareViaTwitter}
            >
              <TwitterIcon size={48} round />
            </TwitterShareButton>
            <span style={{ fontSize: "12px", marginTop: "8px" }}>Twitter</span>
          </div>

          <div
            onClick={shareViaEmail}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <EmailShareButton
              url={genLink}
              subject="Join TaskPlanet with my referral"
              body={referralMessage}
              onClick={shareViaEmail}
            >
              <EmailIcon size={48} round />
            </EmailShareButton>
            <span style={{ fontSize: "12px", marginTop: "8px" }}>Email</span>
          </div>

          <div
            onClick={copyToClipboard}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              position: "relative",
            }}
          >
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#6e6e6e",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              {copied ? (
                <FaCheckCircle size={24} color="white" />
              ) : (
                <FaCopy size={24} color="white" />
              )}
            </div>
            <span style={{ fontSize: "12px", marginTop: "8px" }}>
              {copied ? "Copied!" : "Copy"}
            </span>
          </div>
        </div>

        <button
          onClick={() => setShowShareModal(false)}
          style={{
            backgroundColor: "#FBEC5D",
            color: "#000",
            border: "none",
            padding: "12px 20px",
            borderRadius: "10px",
            fontWeight: "bold",
            marginTop: "24px",
            width: "100%",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease",
          }}
          className="hover-button"
        >
          Close
        </button>
      </Modal>

      {/* CSS for hover effects */}
      <style>{`
        .hover-scale:hover {
          transform: scale(1.05);
        }
        .hover-grow:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.15);
        }
        .hover-button:hover {
          filter: brightness(1.05);
          transform: translateY(-1px);
          box-shadow: 0 3px 7px rgba(0,0,0,0.15);
        }
      `}</style>
      <>
        <style>
          {`
      .responsive-abcd {
        height: 0rem;
      }

      @media (min-width: 700px) {
        .responsive-abcd {
          height: 5rem;
        }
      }
    `}
        </style>

        <div className="responsive-abcd"></div>
      </>
      <BottomMenu name={"dashboard"} />
    </div>
  );
};

export default ReferralScreen;
